'use strict';

namespace Attractions {

    import Broker = Core.Broker;
    class BasketItem {

        // From response
        Title: string;
        Description: any;
        Date: string;
        LineItemId: string;
        ProductId: string;
        Tickets: {
            Label: string;
            Key: string;
            Value: string;
            Currency: string;
            Price: number;
            Ages: string;
            Id: string;
        }[];

        // UI
        Changes: any = {};
        Totals: any = {};
        SelectedDate: string;
        Validity:any = {};


        constructor (responseData,
                     private attractionService) {
            angular.extend(this, responseData);
            this.orderTickets();
            this.updateTotals();
            this.setDates();
        }

        onChange (changes): void {
            angular.extend(this.Changes, changes);
            this.updateTotals();
        }

        orderTickets (): void {
            let order = {};
            this.Tickets.forEach(o => {
                let key = o.Key;
                order[key] = /adult/.test(key) ? 0 :
                             /:child/.test(key) ? 1 : 2; // i.e. not ':youngchild'
            });
            this.Tickets.sort((a, b): number =>
                order[a.Key] < order[b.Key] ? -1 :
                order[a.Key] > order[b.Key] ? 1 : 0
            );
        }

        flushChanges (): void {
            let changes = this.Changes;
            this.Changes = {};
            return changes;
        }

        updateTotals (): void {
            this.Totals = {total: 0};
            this.Tickets.forEach(o => {
                let amount = Number(o.Value || 0) * Number(o.Price || 0);
                this.Totals[o.Key] = amount;
                this.Totals.total += amount;
            });
        }

        setDates (): void {
            const dates = this.attractionService.getLineItemDates(this);
            this.SelectedDate = dates.selected;
            this.Validity = dates.from  && dates.to
                ? {from: dates.from, to: dates.to} : null;
        }
    }

    class AttractionsBasket {

        items: any[] = [];
        basketId: string;
        totalPrice: number = 0;
        initialising: boolean = true;
        loading: boolean = false;
        error: boolean = false;
        debouncedUpdate: Function;


        constructor (
            private $scope: ng.IScope,
            private $timeout: ng.ITimeoutService,
            private $routeParams: any,
            private $location: ng.ILocationService,
            private $http: ng.IHttpService,
            private attractionService: any,
            private basketService: any,
            private basketStore: any,
            private broker: Broker,
            private attractionDetailsService: any
        ) {
            this.debouncedUpdate = _.debounce(p => this.update(p), 400);
        }

        setBasketItems (lineItems = []): void {
            this.items = [];

            if (lineItems.length) {
                lineItems.forEach(lineItem => {
                    let item = new BasketItem(lineItem, this.attractionService);

                    item.Tickets.forEach(ticket => {
                        this.$scope.$watch(
                            () => ticket.Value,
                            (v, oldV) => {
                                if (v != null && v !== oldV && !this.error) {
                                    item.onChange({
                                        [ticket.Key]: v
                                    });
                                    this.updateTotalPrice();
                                    this.debouncedUpdate(item);
                                }
                            }
                        );
                    });
                    this.items.push(item);
                });
            }
            this.updateTotalPrice();
            this.broker.publish('attractionsBasketUpdated');
        }

        update (item: BasketItem): void {
            // Do nothing if no tickets remain selected
            if (this.totalPrice) {
                this.loading = true;
                this.basketStore.updateAttraction(
                    item.LineItemId,
                    item.flushChanges(),
                    this.basketId
                ).then(res => {
                    if (res.error) {
                        this.error = true;
                        return;
                    }
                    this.error = false;
                    this.loading = false;
                    let basket = res.Basket;
                    this.setBasketItems(basket && basket.LineItems);
                });
            }
        }

        remove (item: BasketItem) {
            this.basketStore.removeAttractionsLineItem(
                item.LineItemId,
                this.basketId
            ).then(res => {
                if (res.error) {
                    this.error = true;
                    return;
                }
                this.error = false;
                let basket = res.Basket;
                this.setBasketItems(basket && basket.LineItems);
            });
        }

        updateTotalPrice (): void {
            this.totalPrice = this.items.reduce(
                (prev: number, item: any) => prev + item.Totals.total, 0);
        }

        book (): void {
            if (this.totalPrice && !this.error) {
                this.loading = true;
                this.basketService.bookAttractionsBasket();
            }
        }
    }

    angular
        .module('attractions')
        .controller('AttractionsBasket', AttractionsBasket);
}
